// @flow
import React from 'react';
import classNames from 'classnames';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  website_url: string,
  staticText: string,
  icon: any,
  className?: string,
};

export const VisitArtistUrl = (props: Props) => {
  const { website_url, staticText, icon, className } = props;
  const containerClassNames = classNames('website-url-container', className);
  return (
    <div
      className={containerClassNames}
      onClick={() => window.open(website_url)}
    >
      <img className={'website-icon-img'} src={icon} />
      <h4>{staticText}</h4>
    </div>
  );
};
